import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { UserController } from "services/user/UserController";
import { Button, Card, Input, Link } from "stories";
import { useFetchState } from "utils/customHooks/useFetchState";
import { useToast } from "utils/customHooks/useToast";
import { z } from "zod";
import classes from "./RequestPasswordCard.module.scss";

const schema = z.object({
  email: z.string().email("Please enter a valid email"),
});

const getDefaultValues = () => ({
  email: "",
});

const RequestPasswordCard = () => {
  const {
    formState: { errors },
    ...form
  } = useForm({
    defaultValues: getDefaultValues(),
    resolver: zodResolver(schema),
  });

  const [fetchState, sendRequest] = useFetchState();
  const user = UserController();
  const { showToast } = useToast();
  const handleResetPassword = (body) => {
    sendRequest(user.requestPasswordReset, body);
  };

  useEffect(() => {
    if (
      !fetchState.isLoading &&
      !fetchState.isError &&
      fetchState.data === ""
    ) {
      showToast("A link has been sent to your email address!", "success");
    }
  }, [fetchState]); //eslint-disable-line
  return (
    <div className={classes["wrapper"]}>
      <Card>
        <div className={classes["content-wrapper"]}>
          <div className={classes["title"]}>Reset Password</div>
          <div className={classes["subtitle"]}>
            We will send a One Time Password (OTP) on the registered email
            address.
          </div>
          <form onSubmit={form.handleSubmit(handleResetPassword)}>
            <Input
              label={"Email Address"}
              placeholder={"name@mail.com"}
              {...form.register("email")}
              error={errors?.email?.message}
            />
            <div className={classes["button-wrapper"]}>
              <Button
                label={"Send OTP to email"}
                loading={fetchState.isLoading}
              />
              <div className={classes["link-wrapper"]}>
                <Link to={"/sign-in"} inherit>
                  Login
                </Link>
              </div>
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
};

export default RequestPasswordCard;
